import requestService from './requestService';

const endpoints = {
  getTranslations: 'customer/translations',
  getTranslation: 'customer/translation',
  getInterpreterTranslations: 'translator/translations',
  getInterpreterTranslation: 'translator/translation',
};

const serviceRequest = async (fn) => {
  try {
    return await fn();
  } catch (e) {
    console.error(e);
    throw e;
  }
};

// The platform list endpoints return at most `limit` rows per request (default 100)
// and no total count, so a single request silently caps both the translations
// list and the sidebar badge at 100 orders (TUL-5374). Page through until a
// short page comes back to get the full list.
const PAGE_SIZE = 100;

const fetchAllPages = async (endpoint) => {
  const all = [];
  for (let offset = 0; ; offset += PAGE_SIZE) {
    const data = await requestService.get(
      endpoint,
      `limit=${PAGE_SIZE}&offset=${offset}`,
      { apiType: 'platform' }
    );
    const page = Array.isArray(data) ? data : ((data && data.translations) || []);
    all.push(...page);
    if (page.length < PAGE_SIZE) {
      return all;
    }
  }
};

export const getTranslations = async () => {
  return serviceRequest(() => fetchAllPages(endpoints.getTranslations));
};

export const getInterpreterTranslations = async () => {
  return serviceRequest(() => fetchAllPages(endpoints.getInterpreterTranslations));
};

export const getTranslation = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.get(`${endpoints.getTranslation}/${encodeURIComponent(id)}`, null, { apiType: 'platform' })
  );
};

export const getInterpreterTranslation = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.get(`${endpoints.getInterpreterTranslation}/${encodeURIComponent(id)}`, null, { apiType: 'platform' })
  );
};

export const downloadTranslationSourceFiles = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.postWithJson(`translator/translation/${encodeURIComponent(id)}/download`, null, {}, { apiType: 'platform' })
  );
};

export const getTranslatedFileUploadUrl = async (id, { filename, fileSize, contentType }) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.postWithJson(
      `translator/translation/${encodeURIComponent(id)}/translated-file/presigned-url`,
      null,
      { filename, fileSize, contentType },
      { apiType: 'platform' }
    )
  );
};

export const confirmTranslatedFileUpload = async (id, attachmentId) => {
  if (!id) throw new Error('Translation ID is required');
  if (!attachmentId) throw new Error('Attachment ID is required');
  return serviceRequest(() =>
    requestService.postWithJson(
      `translator/translation/${encodeURIComponent(id)}/translated-file/confirm`,
      null,
      { attachmentId },
      { apiType: 'platform' }
    )
  );
};

export const deleteTranslatedFile = async (id, attachmentId) => {
  if (!id) throw new Error('Translation ID is required');
  if (!attachmentId) throw new Error('Attachment ID is required');
  return serviceRequest(() =>
    requestService.delete(`translator/translation/${encodeURIComponent(id)}/translated-file/${encodeURIComponent(attachmentId)}`, { apiType: 'platform' })
  );
};

export const completeTranslation = async (id) => {
  if (!id) throw new Error('Translation ID is required');
  return serviceRequest(() =>
    requestService.putWithJson(`translator/translation/${encodeURIComponent(id)}/complete`, null, null, { apiType: 'platform' })
  );
};
